module.exports = __webpack_public_path__ + "static/media/Debi Nogle Headshot.54495e7b.jpeg";